import React, { Suspense } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import PatientInfoContent from "./PatientInfoContent";

const NavBar = React.lazy(() => import("../../components/navBar"));
const TopicBanner = React.lazy(() => import("../../components/topicBanner"));
const Footer = React.lazy(() => import("../../components/footer"));
const PdfModal = React.lazy(() => import("../../components/pdfModal"));

export function PatientInfoJS() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const search = location.search;

  return (
    <Suspense fallback={<div className="loader"></div>}>
      <NavBar push={navigate} />
      <TopicBanner pathname={pathname} search={search} push={navigate} />
      <PatientInfoContent />
      <Footer />
      <PdfModal />
    </Suspense>
  );
}

export default PatientInfoJS;
